import type { ComponentProps, ReactNode } from "react";
import Icon from "carbon-react/esm/components/icon";

type MetricIcon = ComponentProps<typeof Icon>["type"];

interface MetricCardProps {
  children: ReactNode;
  icon: MetricIcon;
  label: string;
  primary?: boolean;
  supportingText?: string;
}

export function MetricCard({ children, icon, label, primary = false, supportingText }: MetricCardProps) {
  return (
    <article className={`metric${primary ? " metric--primary" : ""}`}>
      <div className="metric__header">
        <span aria-hidden="true" className="metric__icon"><Icon fontSize="large" type={icon} /></span>
        <span className="metric__label">{label}</span>
      </div>
      <strong className="metric__value">{children}</strong>
      {supportingText ? <span className="metric__supporting-text">{supportingText}</span> : null}
    </article>
  );
}